import React from 'react';
import './EnvironmentBadge.css';

export default function EnvironmentBadge() {
  const environment = process.env.REACT_APP_ENVIRONMENT?.toUpperCase();

  if (environment !== 'HOMOLOG') {
    return null;
  }

  return (
    <div
      className="environment-badge-floating"
      aria-label="Ambiente de homologação"
      title="Ambiente de homologação"
    >
      <span className="environment-badge-dot" />
      <span className="environment-badge-text">HOMOLOG</span>
    </div>
  );
}
